import React, { useEffect, useRef } from 'react';

import { useRouteWorkspace } from '../../contexts/RouteWorkspaceContext';
import { useDocumentTitleContext } from '../../hooks/useDocumentTitleEvents';
import Flexicon from '../shared/Flexicon';
import MembersPanel from '../shared/MembersPanel';
import { Modal } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalContent } from './ModalContent';
import { ModalTopBar } from './ModalTopBar';

const MembersModal = ({ open, onClose }) => {
  const { workspace } = useRouteWorkspace();
  const { title, setTitle } = useDocumentTitleContext();
  const previousTitleRef = useRef(title);
  const workspaceTitle = workspace?.title || 'Untitled';

  useEffect(() => {
    if (!open) previousTitleRef.current = title;
  }, [open, title]);

  useEffect(() => {
    if (!open) return undefined;

    const previousTitle = previousTitleRef.current;
    setTitle('Members');

    return () => {
      setTitle(previousTitle);
    };
  }, [open, setTitle]);

  return (
    <Modal onClose={onClose} closePlacement="top-left" showClose={{ desktop: true, mobile: true }}>
      <ModalBody className="h-full">
        <ModalTopBar
          title={
            <div className="flex min-w-0 items-center justify-center gap-2">
              <Flexicon resource={workspace} size="size-9" rounded="rounded-sm" />
              <span className="min-w-0 truncate text-sm/5 font-semibold text-black dark:text-neutral-200">{workspaceTitle}</span>
            </div>
          }
        />

        <ModalContent className="min-h-0">
          <MembersPanel />
        </ModalContent>
      </ModalBody>
    </Modal>
  );
};

export default MembersModal;
